import React from 'react'
import PropTypes from "prop-types";
import './uploadComment.scss';
import { translateText } from "../../../getTranslationsMyProfileUploadDocumentation";

export class UploadComment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            heightLocal: '46px',
            lengthText: 0,
            maxLengthLocal: 500,
        };
    }

    onChangeHandler = e => {
        const target = e.target;
        const { heightLocal } = this.state;
        if (target.value === '') {
            target.style.height = heightLocal;
            return this.setState({ value: '', lengthText: 0 });
        } else {
            this.setState({ value: target.value, lengthText: target.value.length });
        }
    };

    handleKeyDown = e => {
        const { style, scrollHeight } = e.target;
        const { heightLocal } = this.state;
        const numberInitialHeight = Number(heightLocal.slice(0, -2));
        style.height = `${Math.max(numberInitialHeight, scrollHeight)}px`;
    };

    render = () => {
        const { value, onChange, onFocus } = this.props;
        const { heightLocal, lengthText, maxLengthLocal } = this.state;

        return (
            <div className={'upload-comment'}>
                <label className={'upload-comment-label'}>{translateText('notesSubTitle')}</label>
                <textarea
                    placeholder={translateText('notesPlaceHolder')}
                    className={'upload-comment-input'}
                    maxLength={maxLengthLocal}
                    style={{
                        height: heightLocal,
                    }}
                    value={value}
                    rows={1}
                    onChange={event => {
                        this.onChangeHandler(event);
                        onChange(event.target.value)
                    }}
                    onKeyDown={this.handleKeyDown}
                    onFocus={onFocus}
                />
                <div className="characters-remaining-indicator">
                    {lengthText} / {maxLengthLocal}
                </div>
            </div>
        );
    };
}

UploadComment.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
}
